import IconWarning from '@mui/icons-material/Warning'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type ErrorDialogProps = {
  onClose: () => void
  message?: string
  httpCode?: string
  statusCode?: number
  errorText?: string
}

export const ErrorDialog: React.FC<ErrorDialogProps> = (props) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  let errorText = props.errorText
  if (props.statusCode === 403) {
    errorText = t('error.noPermission')
  }
  if (props.statusCode === 409) {
    errorText = t('shiftEvent.error.conflictBody')
  }
  const heading =
    props.statusCode === 409
      ? t('shiftEvent.error.conflictHeading')
      : t('shiftEvent.error.onDelete.heading')

  return (
    <Dialog maxWidth="xs" data-test-id="error-on-delete-modal" onClose={props.onClose} open>
      <DialogTitle display="flex" alignItems="center">
        <IconWarning color={'error'} />
        &nbsp; {heading}
      </DialogTitle>
      <DialogContent>
        {props.message || t('shiftEvent.error.onDelete.body')}
        <br />
        {errorText}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
